module.exports = __webpack_public_path__ + "01ea978f/img/lock-icon.bb9c7166.svg";